import UserMenu from "./UserMenu";
import logo from "./../assets/ikoneLogo.png";
import { useEffect, useState } from "react";
import { Usuario } from "../types/types";

function Navegacao({
  token,
  user,
}: {
  token: string | null;
  user: Usuario | null;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {token ? (
        <nav className="navbar navbar-light bg-white shadow-sm p-2 p-md-3">
          <div className="container-fluid d-flex flex-row align-items-center justify-content-between flex-nowrap">
            <a
              className="navbar-brand d-flex align-items-center m-0"
              href="/"
              title="Ikone Automação e Sistemas"
              style={{ minWidth: "120px" }}
            >
              <img
                src={logo}
                alt="Logo"
                className="img-fluid"
                style={{ 
                  maxHeight: "35px",
                  width: "auto",
                  maxWidth: "100%" 
                }} 
              />
            </a>

            <div className="ms-2">
              <UserMenu user={user} />
            </div>
          </div>
        </nav>
      ) : (
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm p-3">
          <div className="container-fluid">
            <a
              className="navbar-brand d-flex align-items-center"
              href="/"
              title="Ikone Automação e Sistemas"
            >
              <img
                src={logo}
                alt="Logo"
                className="img-fluid"
                style={{ maxHeight: "40px", marginLeft: "2rem" }}
              />
            </a>

            <button
              className="navbar-toggler"
              type="button"
              onClick={toggleMenu}
              aria-label="Alternar navegação"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
              <ul
                className={`navbar-nav ms-auto d-flex me-5 justify-content-start ${
                  isOpen ? "mb-3 mt-3" : ""
                } gap-3`}
              >
                <li className="nav-item">
                  <a className="nav-link" href="#produtos">
                    Produtos
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#contato">
                    Contato
                  </a>
                </li>
              </ul>

              <div className={`d-flex align-items-center gap-3`}>
                <a
                  className={`btn btn-primary ${isOpen ? "w-100" : ""}`}
                  href="/area-do-cliente"
                >
                  Área do Cliente
                </a>
              </div>
            </div>
          </div>
        </nav>
      )}
    </>
  );
}

export default Navegacao;